import { createAsyncThunk } from '@reduxjs/toolkit';

import { FetchTableTopDataParams, fetchTableTopData } from '../../api/tableTopData/fetcher';

export const fetchTableTopDataAction = createAsyncThunk(
  'recentResults/fetchTableTopDataAction',
  (params: FetchTableTopDataParams) => fetchTableTopData(params)
);
